module.exports = __webpack_public_path__ + "static/media/Onboarding_Step_2.3622d2a3.png";